module.exports = __webpack_public_path__ + "static/media/247international.cd6c94d7.png";